import { isEmpty, uniq } from 'lodash';

import { EmpPosition, Employee } from '~/data/employee';
import { useOrgUnitHRSupervisor } from '~/data/orgunits';

export const useNewEmployeeProposalInitiators = (
  employee: Employee,
  isLoadingEmployee: boolean,
): number[] => {
  const employeeStatus = isLoadingEmployee
    ? ''
    : employee.empBasicData.fEmpStatus;

  const { empPositionPending = {} as EmpPosition } = isLoadingEmployee
    ? {}
    : employee;

  const orgUnit = !isEmpty(empPositionPending)
    ? empPositionPending?.fInternalPositionUnit
    : '';

  const { data: hrs, isLoading: isLoadingHrs } = useOrgUnitHRSupervisor({
    orgUnitId: orgUnit,
  });

  if (employeeStatus !== 'NEW') {
    return [];
  }

  const pendingManagers = empPositionPending?.fInternalPositionManager
    ? [empPositionPending.fInternalPositionManager]
    : [];

  const pendingHRs =
    !isLoadingHrs && Array.isArray(hrs) && !isEmpty(hrs) ? hrs : [];

  return uniq([...pendingManagers, ...pendingHRs]);
};
